<template>
  <a href="#main" class="bg-brand-500 sr-only top-2 left-2 px-4 py-2 text-white focus:not-sr-only focus:fixed!">
    Skip to main content
  </a>
</template>
